import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { MtnaDialogButton, MtnaDialogComponent, MtnaDialogData } from '@mtna/lib-ui';

import { RdsDialogLink, RdsTextItem, RdsTextLink } from '../core/models/index';
import { RdsApiService } from '../core/services/index';

/**
 * Common application footer, populated by an external configuration.
 *
 * @author Will Davis <will.davis@mtna.us
 */
@Component({
  selector: 'rds-app-footer',
  template: `
    <footer>
      <ul fxLayout="row">
        <li *ngFor="let item of items">
          <ng-container [ngSwitch]="item | rdsAppFooterItemType">
            <a *ngSwitchCase="'LINK'" [attr.href]="$any(item).url" target="_blank">
              {{ item.text }}
            </a>
            <button *ngSwitchCase="'DIALOG'" type="button" (click)="handleRdsDialogLink(item)">{{ item.text }}</button>
            <ng-template [ngSwitchCase]="'TEXT'">{{ item.text }}</ng-template>
          </ng-container>
        </li>
      </ul>
    </footer>
  `,
  styleUrls: ['./app-footer.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RdsAppFooterComponent {
  items: Array<RdsTextItem | RdsTextLink | RdsDialogLink> | null = this.rdsApiService.getConfig('footerItems');

  constructor(private dialog: MatDialog, private rdsApiService: RdsApiService) {}

  handleRdsDialogLink(item: RdsDialogLink) {
    this.dialog.open(MtnaDialogComponent, {
      maxWidth: '600px',
      data: new MtnaDialogData(item.text, item.dialog, [new MtnaDialogButton('CLOSE')]),
    });
  }
}
